module.exports = __webpack_public_path__ + "img/service11.48523670.svg";